import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import camelCase from 'lodash/camelCase';
import find from 'lodash/find';
import { Row, Col, Input, Modal, Button, Icon } from 'components/ui';
import { getError, required, minLength, isEmail } from 'services/forms';
import './style.css';

const validators = {
  name: [required, minLength(2)],
  email: [required, isEmail],
};

class AddRecipient extends Component {
  state = {
    showModal: false,
    name: '',
    email: '',
    templateVariables: {},
    errors: {},
  };

  handleKeyUp = event => {
    if (event.which === 13) this.handleSubmit();
  };

  handleInputChange = event => {
    const { name, value } = event.target;
    this.setState(prevState => ({
      [name]: value,
      errors: { ...prevState.errors, [name]: '' },
    }));
  };

  handleVariableChange = event => {
    const { name, value } = event.target;
    this.setState(prevState => ({
      templateVariables: {
        ...prevState.templateVariables,
        [name]: value,
      },
    }));
  };

  handleKeyUp = event => {
    if (event.which === 13) this.handleSubmit();
  };

  validateValues = async () => {
    const errors = {};
    for (const key in validators) {
      if (Object.hasOwnProperty.call(validators, key)) {
        const validator = validators[key];
        const value = this.state[key];
        errors[key] = await getError(value, validator);
      }
    }
    const hasError = find(errors, v => !!v);
    if (hasError) this.setState({ errors });
    return !hasError;
  };

  getData = () => {
    const { name, email, templateVariables } = this.state;
    return { name, email, ...templateVariables };
  };

  getRecipients = () => {
    const { recipients } = this.props;
    const newRecipients = new Map(recipients);
    let nextKey = newRecipients.size;
    if (nextKey > 0) {
      //resetting the nextKey to be the last recipient Map() item key + 1.
      nextKey = [...newRecipients][newRecipients.size - 1][0] + 1;
    }
    newRecipients.set(nextKey, this.getData());
    return newRecipients;
  };

  handleSubmit = async () => {
    if (!(await this.validateValues())) return;
    const recipients = this.getRecipients();
    this.props.onUpdateRecipients(recipients);
    this.handleHideModal();
  };

  handleShowModal = () => {
    this.setState({ showModal: true });
  };

  handleHideModal = () => {
    this.setState({ showModal: false }, this.reset);
  };

  reset = () => {
    this.setState({ name: '', email: '', templateVariables: {} });
  };

  renderVariables = () => {
    const { templateVariables } = this.state;
    const { template } = this.props;
    const { amp_replace_magic_link: automaticallyReplaceToken } = template;

    return (
      <>
        <Row gutter={8}>
          <Col span={12}>senderVariant</Col>
          <Col span={12}>
            <Input
              className="add-recipient__input"
              helperTxt="Use this to control the sender and avoid email threading"
              name="senderVariant"
              placeholder="senderVariant"
              value={templateVariables['senderVariant']}
              onChange={this.handleVariableChange}
              onKeyUp={this.handleKeyUp}
            />
          </Col>
        </Row>
        {this.props.templateVariables.map(variableKey => (
          <Row gutter={8} key={camelCase(variableKey)}>
            <Col span={12}>{variableKey}</Col>
            <Col span={12}>
              <Input
                className="add-recipient__input"
                defaultValue={
                  variableKey === 'token' && automaticallyReplaceToken
                    ? "Will be automatically replaced from Developer's Matching Database"
                    : undefined
                }
                disabled={variableKey === 'token' && automaticallyReplaceToken}
                name={variableKey}
                placeholder={variableKey}
                value={templateVariables[variableKey]}
                onChange={this.handleVariableChange}
                onKeyUp={this.handleKeyUp}
              />
            </Col>
          </Row>
        ))}
      </>
    );
  };

  renderShowModalButton = () => (
    <Button
      className="add-recipient__open-btn"
      disabled={this.props.disabled}
      size="small"
      onClick={this.handleShowModal}
    >
      <Icon type="plus-circle" />
      &nbsp;Add recipient
    </Button>
  );

  render() {
    const { template } = this.props;
    const { name, email, showModal, errors } = this.state;

    return (
      <div className="add-recipient">
        {this.renderShowModalButton()}
        <Modal
          centered
          visible={showModal}
          width="80vw"
          onCancel={this.handleHideModal}
          onOk={this.handleSubmit}
        >
          <Row gutter={8}>
            <Col span={12}>
              <Input
                className="add-recipient__input"
                error={errors.name}
                helperTxt={errors.name}
                label="Recipient's name"
                name="name"
                placeholder="Name"
                value={name}
                onChange={this.handleInputChange}
                onKeyUp={this.handleKeyUp}
              />
            </Col>
            <Col span={12}>
              <Input
                className="add-recipient__input"
                error={errors.email}
                helperTxt={errors.email}
                label="Recipient's email"
                name="email"
                placeholder="Email"
                value={email}
                onChange={this.handleInputChange}
                onKeyUp={this.handleKeyUp}
              />
            </Col>
          </Row>
          <div className="template-variables">
            <Fragment>
              <h5>Template Variables</h5>
              <p>
                These variable placeholders were found in the{' '}
                <strong>{template.name}</strong> template
              </p>
              <div className="add-recipients__template-variables">
                {this.renderVariables()}
              </div>
            </Fragment>
          </div>
        </Modal>
      </div>
    );
  }
}

AddRecipient.defaultProps = {
  template: {},
  templateVariables: [],
};

AddRecipient.propTypes = {
  recipients: PropTypes.instanceOf(Map).isRequired,
  template: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    subject: PropTypes.string,
    template: PropTypes.string,
  }),
  templateVariables: PropTypes.array,
  onUpdateRecipients: PropTypes.func.isRequired,
};

export default AddRecipient;
